<template>
  <b-modal
    cancel-variant="outline-secondary"
    ok-title="Create"
    title="Create User"
    :visible="visible"
    @change="val => $emit('update:visible', val)"
    @ok.prevent="handleOk"
  >
    <template v-if="user">

      <validation-observer ref="formRef" #default="{invalid}">
        <b-row>
          <b-col md="12">
            <b-form-group label="Name">
              <validation-provider #default="{ errors }" name="details">
                <b-form-input
                  v-model="user.name"
                  :state="errors.length > 0 ? false:null"
                  type="text"
                  placeholder="Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Email">
              <validation-provider #default="{ errors }" name="email" rules="required">
                <b-form-input
                  v-model="user.email"
                  :state="errors.length > 0 ? false:null"
                  type="text"
                  placeholder="Email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <hr>

        <b-row>
          <b-col md="12">
            <b-form-group label="Password">
              <validation-provider #default="{ errors }" name="password">
                <b-input-group class="input-group-merge">
                  <b-form-input
                    v-model="user.password"
                    :type="passwordFiledType"
                    placeholder="Password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordIcon"
                      class="cursor-pointer"
                      @click="passwordFiledType = passwordFiledType === 'password' ? 'text' : 'password'"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Password Repeat">
              <validation-provider #default="{ errors }" name="password_repeat">
                <b-input-group class="input-group-merge">
                  <b-form-input
                    v-model="user.passwordRepeat"
                    :type="passwordRepeatFiledType"
                    placeholder="Password Repeat"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordRepeatIcon"
                      class="cursor-pointer"
                      @click="passwordRepeatFiledType = passwordRepeatFiledType === 'password' ? 'text' : 'password'"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>

      <b-overlay no-wrap :show="loading"/>
    </template>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormDatepicker,
  BInputGroup,
  BInputGroupAppend,
  BOverlay,
} from 'bootstrap-vue';
import {ValidationObserver, ValidationProvider} from "vee-validate";
import VSelect from "vue-select";

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import VSelectPaginated from '@core/components/v-select-paginated'

import {createUser} from "@/api/user";
import {required} from "@validations";

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    BOverlay,

    VSelect,
    ValidationProvider,
    ValidationObserver,

    VSelectPaginated
  },
  props: {
    visible: Boolean,
    user: Object,
  },
  data() {
    return {
      required,
      loading: false,
      passwordFiledType: 'password',
      passwordRepeatFiledType: 'password',
    }
  },
  computed: {
    passwordIcon(){
      return this.passwordFiledType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordRepeatIcon(){
      return this.passwordRepeatFiledType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    handleOk() {
      this.$refs.formRef.validate().then(async success => {
        if (success) {

          this.loading = true

          try {
            const {message} = await createUser({
              id: this.user.id,
              name: this.user.name,
              email: this.user.email,
              role_id: this.user.role?.id,
              password: this.user.password,
              password_repeat: this.user.passwordRepeat,
            })

            this.$emit('success');

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {title: message, icon: 'BellIcon', variant: 'success',},
            })

            this.loading = false

          } catch (e) {

            this.loading = false
            this.$refs.formRef.setErrors(e.errors)

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {title: e.message, icon: 'AlertTriangleIcon', variant: 'danger',},
            })
          }
        }
      })
    }
  },
}
</script>
